import { render, staticRenderFns } from "./changeRecord.vue?vue&type=template&id=09a0fcec&scoped=true&"
import script from "./changeRecord.vue?vue&type=script&lang=js&"
export * from "./changeRecord.vue?vue&type=script&lang=js&"
import style0 from "./changeRecord.vue?vue&type=style&index=0&id=09a0fcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a0fcec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a0fcec')) {
      api.createRecord('09a0fcec', component.options)
    } else {
      api.reload('09a0fcec', component.options)
    }
    module.hot.accept("./changeRecord.vue?vue&type=template&id=09a0fcec&scoped=true&", function () {
      api.rerender('09a0fcec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/changeRecord.vue"
export default component.exports